import { Node, mergeAttributes } from '@tiptap/core';

export const Dialogue = Node.create({
  name: 'dialogue',
  group: 'block',
  content: 'inline*',
  marks: 'bold italic underline',

  parseHTML() {
    return [{ tag: 'p[data-type="dialogue"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'p',
      mergeAttributes(HTMLAttributes, {
        'data-type': 'dialogue',
        class: 'play-dialogue',
        spellcheck: 'true',
      }),
      0,
    ];
  },
});
